module.exports = __webpack_public_path__ + "assets/media/footer-image-mob.56aa8725.svg";